<wiz-h-divider width="100%" height="100%" gap="0">

  <wiz-vgroup #vgDetailZone width="200px" minWidth="1px" maxWidth="300px" style="overflow: auto">  
    <ng-container #containerFilter></ng-container>
    <ng-container #containerFields></ng-container>
  </wiz-vgroup>

  <wiz-group width="100%" height="100%" >
      <full-calendar #fullcalendar *ngIf="readyToGo && !tooMany"
      style="max-width: unset !important;"
      schedulerLicenseKey='CC-Attribution-NonCommercial-NoDerivatives'
      [options]="calendarOptions"></full-calendar>
      <wiz-hgroup width="100%" height="100%" verticalAlign="center" horizontalAlign="center" *ngIf="tooMany">
        <wiz-label [wizLabel]="tooManyLabel"></wiz-label>
      </wiz-hgroup>
  </wiz-group>

  </wiz-h-divider>